<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">国内配送パターン詳細</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="!valid || !form.code"
          @click="save"
          v-permit.SHARP_PATTERN_NEW
          >{{ $t("app.buttons.save") }}</v-btn
        >
        <v-btn @click="$router.go(-1)">{{ $t("app.buttons.back") }}</v-btn>
      </v-card-actions>
      <v-form v-model="valid">
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs4>
              <div required>
                <v-text-field
                  :disabled="$route.path.indexOf('new') === -1"
                  :rules="[
                    (v) => !!v || `配送パターンCD is required`,
                    (v) =>
                      v.indexOf('/') === -1 || `配送パターンCD is not legal`,
                  ]"
                  clearable
                  label="配送パターンCD"
                  v-model.trim="form.code"
                ></v-text-field>
              </div>
            </v-flex>
            <v-flex xs4>
              <div required>
                <v-text-field
                  :rules="[(v) => !!v || `配送パターン名 is required`]"
                  clearable
                  label="配送パターン名"
                  v-model="form.name"
                ></v-text-field>
              </div>
            </v-flex>
            <v-flex xs4>
              <date-picker
                label="適用終了日"
                v-model="form.endDate"
              ></date-picker>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4>
              <div required>
                <!-- :label="$t('app.labels.loadingPort')" -->
                <remote-autocomplete
                  :rules="[(v) => !!v || `発地 is required`]"
                  key="departurePortCode"
                  label="発地"
                  url="ports/kv"
                  v-if="form.departureType === 'PORT'"
                  v-model="form.departurePortCode"
                />
              </div>
              <!-- <remote-autocomplete
                key="departureWarehouseId"
                label="発地"
                url="warehouses/sjl-kv"
                v-if="form.departureType === 'WAREHOUSE'"
                v-model="form.departureWarehouseId"
              />-->
            </v-flex>
            <v-flex xs2>
              <remote-select
                :disabled="!canEditDeparture"
                :filter="(p) => p.isDevan"
                item-text="ja_JP"
                item-value="id"
                label="発地作業"
                url="charge-item-sub-type"
                v-model="form.departureWorkId"
              />
            </v-flex>
            <v-flex xs4>
              <!-- :disabled="!canEditDeparture || !form.departureWorkId" -->
              <remote-autocomplete
                :rules="[(v) => !!v || `作業業者 is required`]"
                label="作業業者"
                url="companies/devan/kv"
                v-if="canEditDeparture && form.departureWorkId"
                v-model="form.departureSupplierId"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4>
              <div required>
                <remote-autocomplete
                  :rules="[(v) => !!v || `配送業者１ is required`]"
                  label="配送業者１"
                  url="companies/transport/kv"
                  v-model="form.delivery1Id"
                />
              </div>
            </v-flex>
            <v-flex xs4>
              <remote-select
                :filter="(p) => p.isCharter || p.isDrake || p.isMixLoading"
                :rules="[(v) => !!v || `搬送サービス１ is required`]"
                item-text="ja_JP"
                item-value="id"
                label="搬送サービス１"
                url="charge-item-sub-type"
                v-model="form.deliveryModel1Id"
              />
            </v-flex>
            <v-flex xs4>
              <remote-select
                :rules="[(v) => v != null || `必須項目`]"
                label="Special"
                url="delivery-specials/kv"
                v-if="
                  isDrake(form.deliveryModel1Id) ||
                  isCharter(form.deliveryModel1Id)
                "
                v-model="form.deliverySpecial1Id"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <remote-autocomplete
                label="経由場所"
                url="warehouses/sjl-kv"
                v-model="form.transitWarehouseId"
              />
            </v-flex>
            <v-flex xs2>
              <remote-select
                :disabled="!canEditTransit"
                v-if="form.transitWarehouseId"
                :filter="(p) => p.isDevan"
                item-text="ja_JP"
                item-value="id"
                label="経由作業"
                url="charge-item-sub-type"
                v-model="form.transitWorkId"
              />
            </v-flex>
            <v-flex xs4>
              <!-- :disabled="!canEditTransit || !form.transitWorkId" -->
              <remote-autocomplete
                :rules="[(v) => !!v || `作業業者 is required`]"
                label="作業業者"
                url="companies/devan/kv"
                v-if="canEditTransit && form.transitWorkId"
                v-model="form.transitSupplierId"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs4>
              <remote-autocomplete
                :rules="
                  form.transitWarehouseId
                    ? [(v) => !!v || `配送業者2 is required`]
                    : []
                "
                label="配送業者2"
                url="companies/transport/kv"
                v-model="form.delivery2Id"
              />
            </v-flex>
            <v-flex xs4>
              <remote-select
                :rules="
                  form.transitWarehouseId
                    ? [(v) => !!v || `搬送サービス2 is required`]
                    : []
                "
                :filter="(p) => p.isCharter || p.isDrake || p.isMixLoading"
                item-text="ja_JP"
                item-value="id"
                label="搬送サービス2"
                url="charge-item-sub-type"
                v-model="form.deliveryModel2Id"
              />
            </v-flex>
            <v-flex xs4>
              <remote-select
                :rules="[(v) => v != null || `必須項目`]"
                label="Special"
                url="delivery-specials/kv"
                v-if="
                  isDrake(form.deliveryModel2Id) ||
                  isCharter(form.deliveryModel2Id)
                "
                v-model="form.deliverySpecial2Id"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs6>
              <remote-autocomplete
                :rules="[(v) => v != null || `必須項目`]"
                label="SJL納入場所"
                url="warehouses/kv"
                v-model="form.destinationWarehouseId"
              />
            </v-flex>
            <v-flex xs2>
              <remote-select
                :disabled="!canEditDestination"
                :filter="(p) => p.isDevan"
                item-text="ja_JP"
                item-value="id"
                label="納入作業"
                url="charge-item-sub-type"
                v-model="form.destinationWorkId"
              />
            </v-flex>
            <v-flex xs4>
              <!-- :disabled="!canEditDestination || !form.destinationWorkId" -->
              <remote-autocomplete
                :rules="[(v) => !!v || `作業業者 is required`]"
                label="作業業者"
                url="companies/devan/kv"
                v-if="canEditDestination && form.destinationWorkId"
                v-model="form.destinationSupplierId"
              />
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>
<script>
/* eslint-disable no-console */
export default {
  data() {
    return {
      valid: true,
      departurePlace: null,
      form: {
        departureType: "PORT",
        endDate: "2050-12-31",
      },
      warehouses: [],
      ports: [],
      works: [],
      // locationTypes: [
      //   { value: 'PORT', text: '港' },
      //   { value: 'WAREHOUSE', text: '纳入场所' }
      // ]
      errors: {
        CODE_EXISTS: "当該CDは既に存在しています。",
      },
    };
  },
  computed: {
    places() {
      return this.form.departureWork === "CLEARANCE" || !this.form.departureWork
        ? [...this.warehouses, ...this.ports]
        : this.warehouses;
    },
    canEditDeparture() {
      return !this.form.transitWorkId && !this.form.destinationWorkId;
    },
    canEditTransit() {
      return !this.form.departureWorkId && !this.form.destinationWorkId;
    },
    canEditDestination() {
      return !this.form.departureWorkId && !this.form.transitWorkId;
    },
  },
  watch: {
    departurePlace(val) {
      if (val && val.type != null && val.value != null) {
        this.form.departurePlace = val.value;
        this.form.departurePlaceType = val.type;
        if (val.type == "port") {
          this.form.departurePortCode = val.value;
          console.log(this.form.departurePortCode);
          console.log(val);
        }
        if (val.type == "warehouse") {
          console.log(this.form.departureWarehouseId);
          console.log(val);
          this.form.departureWarehouseId = val.value;
        }
      }
    },
    "form.deliveryModel1Id": function (val) {
      if (val) {
        if (!this.isCharter(val) && !this.isDrake(val)) {
          this.form.deliverySpecial1Id = null;
        }
      }
    },
    "form.deliveryModel2Id": function (val) {
      if (val) {
        if (!this.isCharter(val) && !this.isDrake(val)) {
          this.form.deliverySpecial2Id = null;
        }
      }
    },

    "form.departureWork": function (newVal) {
      this.setWorkHolder(newVal, "departureWork");
    },
    "form.transitWork": function (newVal) {
      this.setWorkHolder(newVal, "transitWork");
    },
    "form.destinationWork": function (newVal) {
      this.setWorkHolder(newVal, "destinationWork");
    },
    "form.transitWarehouseId": function (newVal) {
      if (!newVal) {
        this.form.delivery2Id = null;
        this.form.deliveryModel2 = null;
        this.form.transitWorkId = null;
        this.form.transitSupplierId = null;
      }
    },
  },
  created() {},
  methods: {
    isCharter(deliveryModelId) {
      return deliveryModelId == "CHARGE_ITEM_SUB_TYPE-CHARTER";
    },
    isDrake(deliveryModelId) {
      return deliveryModelId == "CHARGE_ITEM_SUB_TYPE-DRAKE";
    },
    save() {
      this.$http
        .post("/patterns", this.form)
        .then(() => {
          this.$router.go(-1);
        })
        .catch((err) => {
          this.$showError(err);
        });
    },
    setWorkHolder(work, holder) {
      let w = this.works.find((w) => w.holder === holder);
      if (w) this.$set(w, "holder", null);
      let v = this.works.find((w) => w.value === work);
      if (v) this.$set(v, "holder", holder);
    },
    enabled(holder) {
      return (
        this.works.find((w) => w.holder === holder) ||
        this.works.find((w) => !w.holder)
      );
    },
    holderWorks(holder) {
      return this.works.filter((w) => w.holder === holder || !w.holder);
    },
  },
};
</script>
